import {Component, Input, OnInit, signal} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {DcpBundleTemplate, FeatureTogglesService} from '@dcp/configurator';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Product} from '@spartacus/core';
import {CurrentProductService} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';

import '@ui5/webcomponents-icons/dist/cart-4.js';
import '@ui5/webcomponents-icons/dist/add-document.js';
import '@ui5/webcomponents-icons/dist/arrow-top.js';
import '@ui5/webcomponents-icons/dist/add-calendar.js';
import {CtaWebcomponentWrapperComponent} from './cta-webcomponent-wrapper/cta-webcomponent-wrapper.component';
import {AsyncPipe} from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'dcp-cta-form',
  templateUrl: './cta-form.component.html',
  styleUrls: ['./cta-form.component.scss'],
  imports: [CtaWebcomponentWrapperComponent, AsyncPipe],
})
export class CtaFormComponent implements OnInit {
  @Input() bundleTemplate: DcpBundleTemplate;
  @Input() isHeroSection: boolean = false;
  @Input() isPublisherSection: boolean = false;

  product$: Observable<Product>;

  gRecaptchaId = signal<string>('g-recaptcha-cta-wrapper');
  showCaptchaContainer = toSignal(this.featureToggleService.isEnabled(UNLEASH_TOGGLES.leadFormCaptcha), {
    initialValue: false,
  });
  ctaSelectionModalEnabled = toSignal(
    this.featureToggleService.isEnabled(UNLEASH_TOGGLES.ctaAppCtaSelectionModalEnabled),
    {initialValue: false},
  );

  constructor(
    protected currentProductService: CurrentProductService,
    protected featureToggleService: FeatureTogglesService,
  ) {}

  ngOnInit() {
    this.product$ = this.currentProductService.getProduct();
  }
}
